import React, { useEffect, useState } from "react";
import { getBankTnx  ,updateBankTnx} from "../../../services/apiService";

const OfflineOrders = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [offlineOrders, setOfflineOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [selectedOrder, setSelectedOrder] = useState(null);
const [editTxnNumber, setEditTxnNumber] = useState("");

  // Get Offline Orders
const fetchOfflineOrders = async () => {
  try {
    setLoading(true);

    const res = await getBankTnx();

    console.log("Offline Orders Response:", res);

    // Handle both possible response structures
    const list = Array.isArray(res?.list)
      ? res.list
      : Array.isArray(res?.data?.list)
      ? res.data.list
      : [];

    console.log("Offline Orders List:", list);

    setOfflineOrders(list);
  } catch (error) {
    console.error("Error fetching offline orders:", error);
    setOfflineOrders([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchOfflineOrders();
  }, []);

  // Search
  const filteredOrders = offlineOrders.filter((order) => {
    const customer = order?.customer_details?.[0] || {};

    const searchText = `
      ${order?.orderid || ""}
      ${customer?.first_name || ""}
      ${customer?.username || ""}
      ${customer?.mobile || ""}
      ${customer?.firmname || ""}
      ${order?.tnxorder || ""}
      ${order?.tnxnumber || ""}
      ${order?.orderstatus || ""}
    `.toLowerCase();

    return searchText.includes(search.toLowerCase());
  });
const handleUpdateTxn = async () => {
  if (!selectedOrder?.id) {
    return;
  }

  const payload = {
    id: selectedOrder.id,
    tnxnumber: editTxnNumber,
  };

  try {
    setLoading(true);

    const res = await updateBankTnx(payload);

    console.log("Transaction updated:", res);

    setIsEditModalOpen(false);

  } catch (error) {
    console.error("Update transaction error:", error);
  } finally {
    setLoading(false);
  }
};
  // Pagination
  const totalPages = Math.ceil(
    filteredOrders.length / rowsPerPage
  );

  const startIndex = (currentPage - 1) * rowsPerPage;

  const currentOrders = filteredOrders.slice(
    startIndex,
    startIndex + rowsPerPage
  );
const handleEdit = (order) => {
  console.log("EDIT CLICKED:", order);

  setSelectedOrder(order);
  setEditTxnNumber(order?.tnxnumber || "");
  setIsEditModalOpen(true);
};
  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="offline-orders-container">

      {/* Search */}
      <div className="offline-orders-search">
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={handleSearch}
        />
      </div>

      {/* Table */}
      <div className="offline-orders-table-wrapper">
        <table className="offline-orders-table">

          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer Name</th>
              <th>Mobile</th>
              <th>Order Date</th>
              <th>Amount</th>
              <th>Transaction</th>
              <th>Status</th>
              <th>Actions</th>

            </tr>
          </thead>

          <tbody>

            {loading ? (
              <tr>
                <td colSpan="7" className="offline-no-data">
                  Loading...
                </td>
              </tr>
            ) : currentOrders.length > 0 ? (

              currentOrders.map((order) => {
                const customer =
                  order?.dtl?.[0] || {};

                return (
                  <tr key={order.id}>

                    {/* Order ID */}
                    <td>
                      {order?.orderid || "-"}
                    </td>

                    {/* Customer Name */}
                    <td>
                      {customer?.name || "-"}
                    </td>

                    {/* Mobile */}
                    <td>
                      {customer?.phone || "-"}
                    </td>

                    {/* Order Date */}
                    <td>
                      {order?.orderdate
                        ? new Date(order.orderdate).toLocaleDateString(
                            "en-GB"
                          )
                        : "-"}
                    </td>

                    {/* Amount */}
                    <td>
                      ₹{Number(order?.total || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>

                    {/* Transaction */}
                    <td>
                      {order?.tnxnumber || "-"}
                    </td>

                    {/* Status */}
                    <td>
                      <span
                        className={`offline-order-status ${
                          order?.orderstatus === "Success"
                            ? "completed"
                            : "pending"
                        }`}
                      >
                        {order?.orderstatus || "Pending"}
                      </span>
                    </td>
     <td>
                <button
                  type="button"
                  className="offline-edit-btn"
                  onClick={() => handleEdit(order)}
                >
                  Edit
                </button>
              </td>

                  </tr>
                );
              })

            ) : (

              <tr>
                <td colSpan="7" className="offline-no-data">
                  No orders found
                </td>
              </tr>

            )}

          </tbody>
        </table>
      </div>

      {/* Bottom Controls */}
      <div className="offline-orders-footer">

        {/* Rows per page */}
        <select
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>

        {/* Pagination */}
        <div className="offline-pagination">

          <button
            disabled={currentPage === 1}
            onClick={() =>
              setCurrentPage((prev) => prev - 1)
            }
          >
            Previous
          </button>

          <span>
            {currentPage}/{totalPages || 1}
          </span>

          <button
            disabled={
              currentPage === totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setCurrentPage((prev) => prev + 1)
            }
          >
            Next
          </button>

        </div>
        {isEditModalOpen && (
  <div className="offline-modal-overlay">
    <div className="offline-edit-modal">

      <div className="offline-modal-header">
        <h3>Edit Transaction</h3>

        <button
          type="button"
          onClick={() => setIsEditModalOpen(false)}
          className="offline-modal-close"
        >
          ×
        </button>
      </div>

      <div className="offline-modal-body">

        <div className="offline-form-group">
          <label>Order ID</label>
          <input
            type="text"
            value={selectedOrder?.orderid || ""}
            disabled
          />
        </div>

        <div className="offline-form-group">
          <label>Transaction Number</label>

          <input
            type="text"
            value={editTxnNumber}
            onChange={(e) => setEditTxnNumber(e.target.value)}
            placeholder="Enter transaction number"
          />
        </div>

      </div>

      <div className="offline-modal-footer">

        <button
          type="button"
          className="offline-cancel-btn"
          onClick={() => setIsEditModalOpen(false)}
        >
          Cancel
        </button>

      <button
  type="button"
  className="offline-save-btn"
  onClick={handleUpdateTxn}
  disabled={loading}
>
  {loading ? "Saving..." : "Save"}
</button>

      </div>

    </div>
  </div>
)}
      </div>

      <style>{`

        .offline-orders-container {
          width: 100%;
          padding: 23px 32px 32px;
          box-sizing: border-box;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 5px;
        }

        .offline-orders-search {
          margin-bottom: 16px;
        }

        .offline-orders-search input {
          width: 200px;
          height: 40px;
          padding: 0 12px;
          border: 1px solid #ccc;
          border-radius: 4px;
          outline: none;
          font-size: 14px;
          box-sizing: border-box;
        }

        .offline-orders-search input:focus {
          border-color: #005487;
        }

        .offline-orders-table-wrapper {
          width: 100%;
          overflow-x: auto;
        }

        .offline-orders-table {
          width: 1400px;
          border-collapse: collapse;
          table-layout: fixed;
        }

        .offline-orders-table thead th {
          background: #005487;
          color: #fff;
          height: 43px;
          padding: 0 12px;
          text-align: left;
          font-size: 13px;
          font-weight: 600;
        }

        .offline-orders-table tbody tr {
          height: 45px;
          border-bottom: 1px solid #ddd;
        }

        .offline-orders-table tbody tr:nth-child(even) {
          background: #fafafa;
        }

        .offline-orders-table tbody td {
          padding: 0 12px;
          color: #333;
          font-size: 13px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .offline-orders-table th:nth-child(1),
        .offline-orders-table td:nth-child(1) {
          width: 11%;
        }

        .offline-orders-table th:nth-child(2),
        .offline-orders-table td:nth-child(2) {
          width: 12%;
        }

        .offline-orders-table th:nth-child(3),
        .offline-orders-table td:nth-child(3) {
          width: 9%;
        }

        .offline-orders-table th:nth-child(4),
        .offline-orders-table td:nth-child(4) {
          width: 9%;
        }

        .offline-orders-table th:nth-child(5),
        .offline-orders-table td:nth-child(5) {
          width: 9%;
        }

        .offline-orders-table th:nth-child(6),
        .offline-orders-table td:nth-child(6) {
          width: 16%;
        }

        .offline-orders-table th:nth-child(7),
        .offline-orders-table td:nth-child(7) {
          width: 14%;
        }

        .offline-order-status {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 75px;
          padding: 5px 10px;
          border-radius: 15px;
          font-size: 12px;
          font-weight: 600;
        }

        .offline-order-status.completed {
          color: #168a55;
          background: #e8f7ef;
        }

        .offline-order-status.pending {
          color: #b27600;
          background: #fff4d8;
        }

        .offline-no-data {
          height: 100px !important;
          text-align: center !important;
          color: #888 !important;
        }

        .offline-orders-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 17px;
        }

        .offline-orders-footer select {
          width: 64px;
          height: 39px;
          padding: 0 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
          background: white;
          outline: none;
          font-size: 13px;
        }

        .offline-pagination {
          display: flex;
          align-items: center;
          gap: 22px;
        }

        .offline-pagination button {
          height: 40px;
          padding: 0 13px;
          border: 1px solid #ccc;
          border-radius: 4px;
          background: #fff;
          color: #aaa;
          font-size: 13px;
          cursor: pointer;
        }

        .offline-pagination button:not(:disabled) {
          color: #333;
        }

        .offline-pagination button:not(:disabled):hover {
          border-color: #005487;
          color: #005487;
        }

        .offline-pagination button:disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }

        .offline-pagination span {
          font-size: 14px;
          font-weight: 600;
          color: #111;
        }

        @media (max-width: 768px) {

          .offline-orders-container {
            padding: 20px 15px;
          }

          .offline-orders-table {
            min-width: 900px;
          }

          .offline-orders-footer {
            margin-top: 15px;
          }

        }
          .offline-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.offline-edit-modal {
  width: 420px;
  max-width: 90%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.2);
}

.offline-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.offline-modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.offline-modal-close {
  border: none;
  background: transparent;
  font-size: 26px;
  cursor: pointer;
}

.offline-modal-body {
  padding: 20px;
}

.offline-form-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 16px;
}

.offline-form-group label {
  font-size: 14px;
  font-weight: 600;
}

.offline-form-group input {
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.offline-form-group input:focus {
  border-color: #005487;
}

.offline-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.offline-cancel-btn,
.offline-save-btn {
  padding: 9px 18px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.offline-cancel-btn {
  background: #eee;
}

.offline-save-btn {
  background: #005487;
  color: #fff;
}

.offline-edit-btn {
  border: none;
  background: #005487;
  color: #fff;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
}

      `}</style>
    </div>
  );
};

export default OfflineOrders;